import {
  Box,
  Grid,
  Typography,
  Paper,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createStyles, makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import { GetTaxEmployeeToggleInfoAction, UpdateTaxEmployeeToggleInfoAction } from "../../../../../store/Finance/TaxDeclaration/Action";
const TaxDeclarationConfig = () => {
  const theme = useTheme();
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
      },
    })
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    taxEmployee_toggleInfo, isLoadingToggle
  } = useSelector((state) => state?.FinanceReducer?.TaxDeclarationReducer);
  const [toggleState, setToggleState] = useState(false);
  const [toggleDeclarationState, setToggleDeclarationState] = useState(false);
  const [proofLoading, setProofLoading] = useState(false);
  const [declarationLoading, setDeclarationLoading] = useState(false);
 
  const handleToggleSwitch = (newState, control_type) => {
    const payload = {
      employee_toggle: toggleState, 
      tax_declaration_flag: toggleDeclarationState, 
    };
    if (control_type === "proof") {
      payload.employee_toggle = newState; 
      setProofLoading(true);
    } else if (control_type === "declaration") {
      payload.tax_declaration_flag = newState; 
      setDeclarationLoading(true);
    }
     dispatch(UpdateTaxEmployeeToggleInfoAction(
        {...payload, control_type},
        (error, result) => {
            if (!error && result?.data?.statuscode === 200) {
             setProofLoading(false);
             setDeclarationLoading(false);
            } else {
              setProofLoading(false);
              setDeclarationLoading(false);
            }
          }
      ));
  };
  useEffect(() => {
    if (taxEmployee_toggleInfo?.[0]?.employee_proof_upload !== undefined) {
      setToggleState(taxEmployee_toggleInfo?.[0]?.employee_proof_upload);
    }
    if (taxEmployee_toggleInfo?.[0]?.tax_declaration_flag !== undefined) {
      setToggleDeclarationState(taxEmployee_toggleInfo?.[0]?.tax_declaration_flag);
    }
  }, [taxEmployee_toggleInfo]);
  useEffect(() => {
    dispatch(GetTaxEmployeeToggleInfoAction())
    //eslint-disable-next-line
  }, []);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
          <Paper
            className={classes.Paper}
            sx={{
              borderRadius: "16px",
              width: "100%",
              minHeight: "90px"
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "start", alignItems: "center", gap: "20px" }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  color: theme.palette.primary.contrastText,
                }}
              >
                Tax Proof Upload
              </Typography>
              <Box>
                { (isLoadingToggle || proofLoading) ? (
                  <CircularProgress size={30} />
                ) : (
                  <RadioGroup
                    row
                    value={toggleState ? "true" : "false"}
                    onChange={(e) => handleToggleSwitch(e.target.value === "true", "proof")}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio color="primary" />}
                      label="Enable"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio color="primary" />}
                      label="Disable"
                    />
                  </RadioGroup>
                )}
                
              </Box>
              
            </Grid>
            <Typography
                variant="body1"
                sx={{
                  marginTop: "15px",
                  padding: "10px",
                  backgroundColor: theme.palette.grey[200],
                  borderRadius: "5px",
                }}
              >
              Click to manage tax proof uploads for the financial year.
              </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper
            className={classes.Paper}
            sx={{
              borderRadius: "16px",
              width: "100%",
              minHeight: "90px"
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "start", alignItems: "center", gap: "20px" }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  color: theme.palette.primary.contrastText,
                }}
              >
                Tax Declaration
              </Typography>
              <Box>
                { (isLoadingToggle || declarationLoading) ? (
                  <CircularProgress size={30} />
                ) : (
                  <RadioGroup
                    row
                    value={toggleDeclarationState ? "true" : "false"}
                    onChange={(e) => handleToggleSwitch(e.target.value === "true", "declaration")}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio color="primary" />}
                      label="Enable"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio color="primary" />}
                      label="Disable"
                    />
                  </RadioGroup>
                )}
                
              </Box>
              
            </Grid>
            <Typography
                variant="body1"
                sx={{
                  marginTop: "15px",
                  padding: "10px",
                  backgroundColor: theme.palette.grey[200],
                  borderRadius: "5px",
                }}
              >
                Click to manage tax declarations for the financial year.
              </Typography>
          </Paper>
        </Grid>
    </Grid>
  );
};

export default TaxDeclarationConfig;
